import React from 'react';
import styled from 'styled-components';
import {
  sortableContainer,
} from 'react-sortable-hoc';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const FloatingSelect = ({
  children,
  ...other
}) => {
  return (
    <Container {...other}>
      {children}
    </Container>
  )
}

FloatingSelect.propTypes = {

};

FloatingSelect.defaultProps = {

};

export default sortableContainer(FloatingSelect);
